import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectManagers = (state: StoreSchema) =>
    state.client.cachedClient.managersBrief
